<template>
    <div class="index">
        <div class="input_table">
            <div class="title">新增產品</div>
            <table class="input_type">
                <thead>
                    <tr>
                        <td>項目</td>
                        <td>內容</td>
                        <td>備註</td>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>產品編號</td>
                        <td>
                            <el-input type="number" v-model="title" placeholder="請輸入內容"></el-input>
                        </td>
                        <td>請輸入數字</td>
                    </tr>
                    <tr>
                        <td>產品編號後綴</td>
                        <td>
                            <el-input type="text" v-model="titleSub" placeholder="請輸入內容"></el-input>
                        </td>
                        <td>可不填寫</td>
                    </tr>
                    <tr>
                        <td>分類</td>
                        <td>
                            <el-select v-model="pType" placeholder="選擇分類">
                                <el-option label="Quartz" value="Quartz"></el-option>
                                <el-option label="Natural Granite" value="Natural Granite"></el-option>
                                <el-option label="Outdoor Project" value="Outdoor Project"></el-option>
                                <el-option label="Granite Project" value="Granite Project"></el-option>
                            </el-select>
                        </td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>封面圖片</td>
                        <td>
                            <div class="upload">
                                <el-upload
                                    :before-upload="beforeAvatarUpload"
                                    :on-success="handleAvatarSuccess"
                                    :show-file-list="false"
                                    action="https://api.unitedquartzs.com/upload.php"
                                    class="avatar-uploader"
                                    v-loading="imgLoading"
                                >
                                    <div class="cover_img" v-if="cover" :style="{ backgroundImage: `url(${cover})` }"></div>
                                    <i class="el-icon-plus avatar-uploader-icon" v-else></i>
                                </el-upload>
                            </div>
                        </td>
                        <td>*建議尺寸 419x526 px</td>
                    </tr>
                    <tr>
                        <td>主視覺圖</td>
                        <td class="flex">
                            <div class="image_list" v-for="(item, idx) in imageList" :key="item" :style="{ backgroundImage: `url(${item})` }">
                                <i @click="deletImg(idx, 'main')" class="el-icon-delete trash"></i>
                            </div>
                            <div class="list_upload">
                                <el-upload
                                    :before-upload="imageListBeforeAvatarUpload"
                                    :on-success="imageListHandleAvatarSuccess"
                                    :show-file-list="false"
                                    list-type="picture-card"
                                    action="https://api.unitedquartzs.com/upload.php"
                                    class="avatar-uploader"
                                    v-loading="imgListLoading"
                                >
                                    <i class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                            </div>
                        </td>
                        <td>*建議尺寸 987x583 px</td>
                    </tr>
                    <tr>
                        <td>內容描述</td>
                        <td>
                            <el-input v-model="meta" type="textarea" :rows="4"></el-input>
                        </td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>文末視覺圖</td>
                        <td class="flex">
                            <div class="image_list" v-for="(item, idx) in lastList" :key="item" :style="{ backgroundImage: `url(${item})` }">
                                <i @click="deletImg(idx, 'last')" class="el-icon-delete trash"></i>
                            </div>
                            <div class="list_upload">
                                <el-upload
                                    :before-upload="lastListBeforeAvatarUpload"
                                    :on-success="lastListHandleAvatarSuccess"
                                    :show-file-list="false"
                                    list-type="picture-card"
                                    action="https://api.unitedquartzs.com/upload.php"
                                    class="avatar-uploader"
                                    v-loading="lastListLoading"
                                >
                                    <i class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                            </div>
                        </td>
                        <td>*建議尺寸 304x422 px</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td></td>
                        <td>
                            <el-button :loading="loading" @click="submit()" class="submit" type="success">送出</el-button>
                        </td>
                        <td></td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
</template>
<script>
import { postProduct } from '@/api'
export default {
    data() {
        return {
            loading: false,
            cover: '',
            pType: '',
            meta: '',
            title: '',
            titleSub: '',
            imgLoading: false,
            imgListLoading: false,
            lastListLoading: false,
            imageList: [],
            lastList: []
        }
    },
    watch: {},
    methods: {
        submit() {
            this.loading = true
            if (this.title === '') {
                this.$message.error('請至少填入標題再送出！')
                this.loading = false
            } else {
                let params = {
                    p_type: this.pType,
                    title: this.title,
                    cover: this.cover,
                    image_list: this.imageList,
                    meta: this.meta,
                    image_list_sb: this.lastList,
                    title_sub: this.titleSub
                }
                postProduct(params)
                    .then(() => {
                        this.loading = false
                        this.$message.success('新增成功！')
                        this.$router.push('/')
                    })
                    .catch(() => {
                        this.loading = false
                        this.$message.error('網路異常，請稍後再試！')
                    })
            }
        },
        handleAvatarSuccess(res) {
            this.imgLoading = false
            this.cover = process.env.VUE_APP_IMAGE_URL + '/' + res.url
        },
        beforeAvatarUpload(file) {
            this.imgLoading = true
            const isLt2M = file.size / 1024 / 1024 < 2
            if (!isLt2M) {
                this.$message.error("image size don't over 2MB!")
            }
            return isLt2M
        },
        imageListHandleAvatarSuccess(res) {
            this.imgListLoading = false
            this.imageList.push(process.env.VUE_APP_IMAGE_URL + '/' + res.url)
        },
        imageListBeforeAvatarUpload(file) {
            this.imgListLoading = true
            const isLt2M = file.size / 1024 / 1024 < 2
            if (!isLt2M) {
                this.$message.error("image size don't over 2MB!")
            }
            return isLt2M
        },
        lastListHandleAvatarSuccess(res) {
            this.lastListLoading = false
            this.lastList.push(process.env.VUE_APP_IMAGE_URL + '/' + res.url)
        },
        lastListBeforeAvatarUpload(file) {
            this.lastListLoading = true
            const isLt2M = file.size / 1024 / 1024 < 2
            if (!isLt2M) {
                this.$message.error("image size don't over 2MB!")
            }
            return isLt2M
        },
        deletImg(idx, type) {
            if (type === 'main') {
                this.imageList.splice(idx, 1)
            } else {
                this.lastList.splice(idx, 1)
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.title {
    font-size: $font-size-3;
    margin-bottom: 20px;
    font-family: $font-3;
    border-left: 5px solid $color-green;
    color: $color-green;
    padding-left: 10px;
    font-weight: bold;
    margin-left: 20px;
}
.input_table {
    width: 100%;
    box-shadow: 0 0 5px #ccc;
    border-radius: $radius;
    background: #fff;
    padding: 20px 0px 10px 0;
}
table {
    width: 100%;
    background: #fff;
    text-align: center;

    border-collapse: collapse;
}
.input_type {
    line-height: 30px;
    tr {
        padding: 5px 0;
    }
}
input {
    border: 1px #ccc solid;
    border-radius: $radius;
    outline: none;
    width: 80%;
    padding: 0 10px;
    line-height: 30px;
    height: 30px;
}
thead tr,
tbody tr {
    border-bottom: 1px #eee solid;
    height: 40px;
    line-height: 40px;
}
thead {
    border-top: 1px #eee solid;
    border-bottom: 1px #eee solid;
    background: $color-green;
    color: #fff;
}
tbody {
    background: #fff;
}
tbody tr:nth-of-type(odd) {
    background: #f8fcff;
}
tbody tr td {
    text-align: left;
    padding: 10px;
    &:nth-child(3) {
        color: #999;
    }
}
tbody tr td:nth-child(1),
thead tr td:nth-child(1) {
    width: 100px;
    border-right: 1px #eee solid;
}
tbody tr td:nth-child(2),
thead tr td:nth-child(2) {
    border-right: 1px #eee solid;
}
li {
    width: 100%;
    margin: 0;
}
ul {
    height: 30px;
}
tfoot td {
    text-align: left;
    padding: 10px;
}
.el-upload {
    border: 1px dashed #ccc;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 148px;
    height: 148px;
    line-height: 148px;
    text-align: center;
}
.avatar {
    width: 148px;
    height: 148px;
    display: block;
}
.upload {
    width: 148px;
    height: 148px;
    border: 1px dashed #ccc;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.note {
    color: #999;
    line-height: 20px;
}
.unit {
    width: 100px;
}
.unit_row {
    position: relative;
    width: 400px;
}
.unit_plus {
    position: absolute;
    top: 0;
    right: 0;
}
.el-button.is-circle {
    width: 30px;
    height: 30px;
    padding: 0;
}
.less {
    height: 30px;
    width: 30px;
    float: right;
}
.unit_add {
    color: $color-blue;
}
.no_power {
    color: #999;
}
.quillWrapper {
    background: #fff;
}
.flex {
    display: flex;
    flex-flow: row wrap;
}
.list_upload {
    width: 148px;
    height: 148px;
}
.image_list {
    position: relative;
    height: 148px;
    width: 148px;
    margin-right: 10px;
    background-size: cover;
    background-position: center;
    img {
        width: 148px;
    }
    i {
        position: absolute;
        top: 0px;
        right: 0px;
        color: #fff;
        background: rgba(0, 0, 0, 0.5);
        padding: 10px;
    }
}
.mb10 {
    margin-bottom: 10px;
}
.mt10 {
    margin-top: 10px;
}
.cover_img {
    background-position: center;
    background-size: cover;
    width: 148px;
    height: 148px;
}
</style>
